import {useQuery} from '@tanstack/react-query';
import {apiClient} from '../../../../lib/api-client';
import {ZipCodeInformation} from "../types/ZipCodeInformation";

export const useZipCodeInformation = (zipCode: string) => {
    const { data, isLoading } = useQuery({
        queryKey: ['ee-pro-zip', zipCode],
        queryFn: async () => await apiClient.get('ee-tool/zip?zipCode=' + zipCode) as ZipCodeInformation,
        enabled: zipCode !== undefined && zipCode.length === 5,
        staleTime: 5 * 60 * 1000
    });

    return {
        data: data || {} as ZipCodeInformation,
        isLoading: isLoading
    };
};
